import { render, staticRenderFns } from "./FoodcourtCargosList.vue?vue&type=template&id=7be073b0&scoped=true"
import script from "./FoodcourtCargosList.vue?vue&type=script&lang=js"
export * from "./FoodcourtCargosList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtCargosList.vue?vue&type=style&index=0&id=7be073b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be073b0",
  null
  
)

export default component.exports